module.exports = __webpack_public_path__ + "img/news6.46f31e93.png";